import CheckSymbol from 'components/elements/symbols/CheckSymbol'
import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

import ItemLine from './ItemLine'

/**
 * 対象がCheckLineProps型かチェックする
 * @param target チェック対象
 */
export const isCheckLineProps = (target: any): target is CheckLineProps => {
  return target.isChecked !== undefined && target.label !== undefined
}

/**
 * 選択肢のチェック行
 */
const CheckLine: React.FC<CheckLineProps> = (props) => {
  return (
    <ItemLine
      isHide={props.isHide}
      onClick={props.onClick}
      showLineBorder
      lineOffset="54px"
    >
      <SymbolArea>
        <CheckSymbol height="24px" width="24px" isChecked={props.isChecked} />
      </SymbolArea>
      <TextArea>
        <Text>{props.label}</Text>
      </TextArea>
    </ItemLine>
  )
}

export type CheckLineProps = {
  isChecked: boolean
  label: string
  isHide?: boolean
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

const SymbolArea = styled.div`
  height: 24px;
  margin-right: 12px;
  margin-left: 18px;
`

const TextArea = styled.div`
  flex: 1;
`

export default CheckLine
